// @flow
import React from 'react';
import { P } from '../Typography';
import styles from './styles.module.scss';

type Props = {
  name: string,
  color: string,
}

const Legend = ({ name, color }: Props) => (
  <div className={styles.wrapper}>
    <div className={styles.item} style={{ background: color }} />
    <P>{name}</P>
  </div>
);

export default Legend;
